import { Platform } from 'react-native'

import { Cookie } from '@/src/general/utils/cookies/Cookie'

import { authTokenStorage } from './authTokenStorage'

/**
 * Loads the token based on the platform,
 * stores the token in local storage for web platform.
 */
export const loadToken = () => {
  if (Platform.OS === 'web') {
    const legacyToken = Cookie.get('jwtToken')
    if (legacyToken) {
      authTokenStorage.setToken(legacyToken || '')
    }
  }
}
